export default __webpack_public_path__ + "static/media/address.de6a61e1.svg";